var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-conversation__loader"},[_c('div',{ref:"chatLoader",staticClass:"chat-conversation__loader-content"},[_c('check-load-circle',{staticClass:"chat-conversation__loader-content--icon"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }